module.exports = __webpack_public_path__ + "static/media/compDashboardInactive.8b5bf195.png";